import { type FC, useCallback } from 'react';

import { MAP_ZOOM_DURATION } from '../../../constants/map';
import { useMapStoreContext } from '../../../context/mapStoreContext';

import { ZoomIn } from './ZoomIn';

export const ZoomInContainer: FC = () => {
  const { map } = useMapStoreContext();

  const handleClick = useCallback(() => {
    const zoom = map.getZoom();
    const [, maxZoom] = map.zoomRange.getCurrent();

    if (zoom >= maxZoom) {
      return;
    }

    map.setZoom(zoom + 1, { duration: MAP_ZOOM_DURATION });
  }, [map]);

  return <ZoomIn handleClick={handleClick} />;
};
